import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiDialog = (theme: Theme): Partial<Components> => ({
  MuiDialog: {
    styleOverrides: {
      root: {
        '& .MuiBackdrop-root': {
          backgroundColor:
            theme.palette.mode === 'light'
              ? 'rgba(0,0,0,0.75)'
              : 'rgba(48,51,64,0.95)',
        },
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('xs')]: {
          margin: '0',
        },
        borderRadius: '12px',
      },
      paperFullWidth: {
        margin: '0 16px',
        width: '100%',
        [theme.breakpoints.up('lg')]: {
          margin: '0',
        },
      },
    },
  },
});

export const MuiDialogTitle = (theme: Theme): Partial<Components> => ({
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        ...theme.typography.header1_medium,
        padding: theme.new.spacing.medium,
        display: 'flex',
        justifyContent: 'space-between',
        '& svg': {
          fill: theme.new.color.textSecondary,
        },
      },
    },
  },
});

export const MuiDialogContent = (theme: Theme): Partial<Components> => ({
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: '8px 16px 16px',
        margin: '0',
      },
      dividers: {
        borderTop: `2px solid ${theme.palette.primary.light}`,
      },
    },
  },
});
